import { getBackendPath } from 'app/utils/paths';
import { createMockableFunction } from 'app/utils/mock';

export const cacheBuster = createMockableFunction(() => `timestamp=${Date.now()}`);

export const GET_PARAMS    = Object.freeze({ method: 'GET' } as const);
export const DELETE_PARAMS = Object.freeze({ method: 'DELETE' } as const);
export const POST_PARAMS   = Object.freeze({ method: 'POST' } as const);
export const PUT_PARAMS    = Object.freeze({ method: 'PUT' } as const);

export const getPresence = () => ({
  ...GET_PARAMS,
  // This API should never be cached.
  url: `${getBackendPath()}/api/presence?${cacheBuster()}`,
});
